import { render, staticRenderFns } from "./CheckoutList.vue?vue&type=template&id=b8a5b8b0"
import script from "@/controllers/custom/checkout/checkout-list.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/checkout/checkout-list.js?vue&type=script&lang=js&external"
import style0 from "./CheckoutList.vue?vue&type=style&index=0&id=b8a5b8b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports